<template>
  <div class="row">
    <div class="col-md-3">
      <form class="needs-validation" ref="form" id="form">
        <div class="form-group">
          <label class="mb-0" for="Operator">Operator: </label>
          <select class="form-control" v-model="operator" required>
            <option
              v-for="operator in operators"
              :key="operator.id"
              :value="operator.id"
            >
              {{ operator.username }}
            </option>
          </select>
        </div>

        <!--        <div class="mb-1 form-group" v-for="(batch, index) in ribbonBatches" :key="index">-->
        <!--          <label class="mb-0" :for="'RibbonBatch' + index">Ribbon Batch {{ index + 1 }}: </label>-->
        <!--          <input type="text" class="form-control" v-model="ribbonBatches[index]" :id="'RibbonBatch' + index" required>-->
        <!--        </div>-->
        <div
          class="mb-1 form-group"
          v-for="index in ribbonFieldCount"
          :key="index"
        >
          <label class="mb-0" :for="'RibbonBatch' + index"
            >Ribbon Batch {{ index }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="ribbonBatches[index - 1]"
            :id="'RibbonBatch' + index"
            required
          />
        </div>

        <div class="mb-1 form-label">
          <label class="form-check-label">Produktionslinie ATW Stringer</label>
        </div>

        <div class="mb-1 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="productionLineATWStringer"
            id="radio1"
            value="A"
            v-model="productionLine"
          />
          <label class="from-check-label" for="radio1"> A </label>
        </div>
        <div class="mb-1 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="productionLineATWStringer"
            id="radio2"
            value="B"
            v-model="productionLine"
          />
          <label class="from-check-label" for="radio2"> B </label>
        </div>

        <div class="mb-3 form-group">
          <label class="mb-0" for="remarks">Bemerkungen: </label>
          <input class="form-control" type="text" v-model="remarks" />
        </div>

        <div class="row justify-content-around">
          <div class="col-3">
            <button
              type="button"
              class="btn btn-primary mb-3"
              @click="submit()"
            >
              Speichern
            </button>
          </div>
          <div class="col-9">
            <button
              type="button"
              class="btn btn-secondary mb-3"
              @click="resetForm()"
            >
              Zurücksetzen
            </button>
          </div>
        </div>
      </form>

      <transition name="alert">
        <div
          class="alert alert-success mt-1"
          role="alert"
          v-if="triggerSuccess"
        >
          Der Eintrag wurde gespeichert!
        </div>
      </transition>

      <transition name="alert">
        <div class="alert alert-danger mt-1" role="alert" v-if="triggerError">
          Eintrag konnte nicht gespeichert werden!
        </div>
      </transition>

      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerWarning"
        >
          Bitte füllen Sie alle nötigen Felder aus!
        </div>
      </transition>
    </div>

    <div class="col-md-9">
      <RibbonTable :url="props.tableUrl" :key="componentKey" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, watch, computed } from "vue";
import RibbonTable from "@/components/ribbon/RibbonTable.vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  stationId: {
    type: Number,
    required: true,
  },
  tableUrl: {
    type: String,
    required: true,
  },
});

const componentKey = ref(0);
let operator = ref();
let ribbonBatches = ref([""]);
let productionLine = ref();
let remarks = ref();

const operators = ref([]);

let triggerSuccess = ref(false);
let triggerError = ref(false);
let triggerWarning = ref(false);

const ribbonFieldCount = computed(() => {
  let count = ribbonBatches.value.length;

  // If the last input field is not empty and count is less than 5, add another field
  if (ribbonBatches.value[count - 1] && count < 5) {
    return count + 1;
  }
  return count;
});

onMounted(async () => {
  try {
    const { data } = await axios.get("/User/GetUsersByJobtype/2");
    operators.value = data
      .map(({ id, username }) => ({ id, username }))
      .sort((a, b) => a.username.localeCompare(b.username));
  } catch (error) {
    console.log(error.message);
  }
});

watch(
  ribbonBatches,
  (newValues) => {
    let lastIndexFilled = newValues.length - 1;

    // Find the last index where the input is filled
    for (let i = 0; i < newValues.length - 1; i++) {
      if (!newValues[i]) {
        lastIndexFilled = i - 1;
        break;
      }
    }

    // Adjust the array length
    if (lastIndexFilled < newValues.length - 1) {
      ribbonBatches.value.splice(lastIndexFilled + 1);
    }

    // Handle the '$' character
    newValues.forEach((value, index) => {
      if (value && value.includes("$")) {
        ribbonBatches.value[index] = value.slice(value.indexOf("$") + 1);
      }
    });
  },
  { deep: true }
);

function resetForm() {
  operator.value = null;
  ribbonBatches.value = [""];
  componentKey.value += 1;
  productionLine.value = null;
  remarks.value = null;
}

async function submit() {
  //checks form validity, because standard form validation doesn't work due to incompatibilities of bootstrap/vue3
  if (
    operator.value == null ||
    ribbonBatches.value[0] === "" ||
    productionLine.value == null
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  }

  const currentDate = new Date().toISOString();
  for (let i = 0; i < ribbonBatches.value.length; i++) {
    console.log(ribbonBatches.value[i]);
  }

  let jsonObject = {
    operatorid: operator.value,
    stationid: props.stationId,
    dateInProduction: currentDate,
    ribbonBatch: ribbonBatches.value[0],
    manufactureDate: null,
    productionlineATWStringer: productionLine.value,
    remarks: remarks.value,
  };

  try {
    await axios.post("/Material/AddMaterialribbon", jsonObject);
  } catch (e) {
    console.log(e.message);
    triggerError.value = true;
    setTimeout(() => (triggerError.value = false), 5000);
    resetForm();
    return;
  }
  //success alert
  triggerSuccess.value = true;
  setTimeout(() => (triggerSuccess.value = false), 5000);

  if (ribbonBatches.value.length === 1) {
    resetForm();
  } else {
    ribbonBatches.value.shift();
  }
  remarks.value = null;
  componentKey.value += 1;
}
</script>

<style scoped>
.alert-enter-active,
.alert-leave-active,
.modal-enter-active {
  transition: opacity 0.5s ease;
}
.alert-enter-from,
.alert-leave-to,
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

input[type="radio"] {
  transform: scale(1.3);
}
input[type="checkbox"] {
  transform: scale(1.2);
}
</style>
